<template>
    <nav class="navbar px-navbar">
        <!-- Header -->
        <div class="navbar-header">
            <a class="navbar-brand px-demo-brand" v-bind:href="'/'"><span class="px-demo-logo bg-primary"><span class="px-demo-logo-1"></span><span class="px-demo-logo-2"></span><span class="px-demo-logo-3"></span><span class="px-demo-logo-4"></span><span class="px-demo-logo-5"></span><span class="px-demo-logo-6"></span><span class="px-demo-logo-7"></span><span class="px-demo-logo-8"></span><span class="px-demo-logo-9"></span></span>WTDBackoffice</a>
        </div>   
        <!-- Navbar togglers -->
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#px-demo-navbar-collapse" aria-expanded="false"><i class="navbar-toggle-icon"></i></button>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="px-demo-navbar-collapse">
            <ul class="nav navbar-nav">
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="fa fa-bookmark m-r-1"></i>Campaigns</a>
                <ul class="dropdown-menu">
                  <li  v-for="(str, index) in campaignList" :key="index" ><a v-on:click="selectCampaign(str.campaign_code,str.name)"  >{{str.name}}</a></li>
                </ul>
              </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
              <li>
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <img  v-bind:src="avatar" alt="" class="px-navbar-image">
                  <span class="hidden-md"><strong>{{ username }}</strong></span>
                </a>
              </li>
                <li>
                    <a href="" @click="logout"><i class="dropdown-icon fa fa-power-off"></i>&nbsp;&nbsp;Log Out</a>
                </li>
            </ul>    
        </div>
    </nav>    
</template>

<script>
import Vue from 'vue'
import axios from '~/plugins/axios'
export default {
  data() {
    return {
      avatar: "",
      username: "",
      formError: null,
      formUsername: '',
      formPassword: '',
      campaignList: [],
      campaignCodeList: [],
      currentCampaignCode:"",
      currentCampaignName:""
    }
  },
  mounted: function() {
    if(this.$store.state.authUser && this.$store.state.authUser.rbac){
      this.username = this.$store.state.authUser.username
      this.avatar = this.$store.state.authUser.user.avatar;
      this.getCamapign();
    }

  },
  methods: {
    async getCamapign () {
      let { data } = await axios.get("/api/campaign");
      let campaignList = [];
      let campaignCodeList = [];
      let campaignCodeAllow = await this.getAllCampaign();
      for (const val of data) {
        for (const campaign_code of campaignCodeAllow) {
          if(campaign_code == val.campaign_code){
            campaignList.push(val);
            campaignCodeList.push({"code":val.campaign_code,"name":val.name});
          }
        } 
      }

      if(!localStorage.getItem("now_campaign_code")){
        this.currentCampaignCode = campaignCodeList[0].code;
        localStorage.setItem("now_campaign_code",  this.currentCampaignCode);
      }

      if(!localStorage.getItem("now_campaign_name")){
        this.currentCampaignName = campaignCodeList[0].name;
        localStorage.setItem("now_campaign_name",  this.currentCampaignName);
      }

      this.campaignList = campaignList;
      
      return this.campaignList;
    },
    selectCampaign(campaign_code,name){
      //alert(campaign_code);
      localStorage.clear();
      this.currentCampaignCode = campaign_code;
      this.currentCampaignName = name;
      localStorage.setItem("now_campaign_code",  this.currentCampaignCode);
      localStorage.setItem("now_campaign_name",  this.currentCampaignName);
      location.href = "/home";
    
    },
    async getAllCampaign () {
      let url = "/api/users/get_all_campaign/";
      let { data } = await axios.get(url);
      return data.campaign;
    },
    async logout() {
      try {
        localStorage.clear();
        await this.$store.dispatch('logout');
        window.location.href = `https://accounts.trueid.net/signout?client_id=1571&redirect_uri=${process.env.baseURL}&state=home`;     
      } catch (e) {
        this.formError = e.message
      }    
    }
  }
}
</script>